import {go} from './Scene.js';

let canvas = document.getElementById('babylonCanvas')

go(canvas);
